import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-on-surface font-body pb-20" dir="rtl">
      {/* ── Header ── */}
      <header className="sticky top-0 z-50 bg-[#f9f9f9]/80 backdrop-blur-md px-6 py-4 flex items-center gap-4">
        <button 
          onClick={() => navigate(-1)} 
          className="p-2 rounded-full hover:bg-surface-container transition-colors active:scale-95"
        >
          <span className="material-symbols-outlined text-primary">arrow_forward</span>
        </button>
        <h1 className="font-headline font-bold text-xl text-primary">מדיניות פרטיות</h1>
      </header>

      <main className="max-w-2xl mx-auto px-6 pt-8">
        <div className="bg-surface-container-lowest rounded-2xl p-8 recipe-card-shadow border border-outline-variant/10">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
              <span className="material-symbols-outlined text-primary text-2xl">shield</span>
            </div>
            <div>
              <h2 className="text-2xl font-headline font-extrabold text-on-surface leading-tight">הפרטיות שלך חשובה לנו</h2>
            </div>
          </div>

          <div className="space-y-8 text-on-surface-variant leading-relaxed text-base">
            <section>
              <h3 className="text-lg font-headline font-bold text-on-surface mb-3 flex items-center gap-2">
                <span className="w-1.5 h-6 bg-primary rounded-full" />
                1. איסוף מידע
              </h3>
              <p>אנו אוספים מידע בסיסי בלבד כגון כתובת אימייל ושם משתמש לצורך זיהוי במערכת וסנכרון ספר המתכונים האישי שלך בין מכשירים שונים. המידע נשמר בצורה מאובטחת.</p>
            </section>

            <section>
              <h3 className="text-lg font-headline font-bold text-on-surface mb-3 flex items-center gap-2">
                <span className="w-1.5 h-6 bg-primary rounded-full" />
                2. שימוש בעוגיות ופרסומות
              </h3>
              <p>האפליקציה משתמשת בשירותי צד ג', כולל Google AdSense, לצורך הצגת פרסומות מותאמות אישית. שירותים אלו עשויים להשתמש בעוגיות כדי לאסוף מידע על העדפות הגלישה שלך ולשפר את חווית המשתמש.</p>
            </section>

            <section>
              <h3 className="text-lg font-headline font-bold text-on-surface mb-3 flex items-center gap-2">
                <span className="w-1.5 h-6 bg-primary rounded-full" />
                3. מידע מצד ג'
              </h3>
              <p>בעת חילוץ מתכון מסרטון (אינסטגרם, טיקטוק וכו'), האפליקציה מעבדת את המידע הציבורי הזמין בלבד. איננו שומרים מידע אישי מהפלטפורמות הללו מעבר למה שנדרש ליצירת המתכון עבורך.</p>
            </section>

            <section>
              <h3 className="text-lg font-headline font-bold text-on-surface mb-3 flex items-center gap-2">
                <span className="w-1.5 h-6 bg-primary rounded-full" />
                4. אבטחת מידע
              </h3>
              <p>המידע שלך נשמר בשרתים מאובטחים של Google Firebase. אנו עושים מאמצים רבים להגן על המידע, אך זכור כי אף שיטת העברה באינטרנט אינה בטוחה ב-100%.</p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-outline-variant/20 text-center">
            <p className="text-sm text-on-surface-variant italic">
              יש לך שאלות? מוזמן ליצור קשר דרך ערוצי התמיכה שלנו.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;